export enum PaymentProviderType {
	None = 0,
	Bog = 1,
	Flitt = 2,
}

export type PaymentSettingsDto = {
	provider: PaymentProviderType;
	authUrl?: string;
	apiUrl?: string;
	clientIdMasked?: string;
	hasSecret: boolean;
	secretMasked?: string;
	callbackPublicKey?: string;
};

export type UpdatePaymentSettingsDto = {
	provider: PaymentProviderType;
	authUrl?: string;
	apiUrl?: string;
	clientId?: string;
	secret?: string;
	callbackPublicKey?: string;
};
